export default [
  {
    path: '/time/all',
    component: () => import('./RouteTimeAll.vue'),
  },
];
